import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ArrowrightIcon from 'icons/Arrowright.icon';
import useNdaStatus from 'hooks/useNdaStatus';
import { Lead } from 'models/Lead';
import { isNdaSent } from 'utils';

import './ResendNda.styles.scss';

type ResendNdaProps = {
  className?: string;
  lead: Lead;
};

const ResendNda: React.FC<ResendNdaProps> = (props) => {
  const { className, lead } = props;

  const classes = classNames('resend-nda', className);

  const { t } = useTranslation();

  const { _id: leadId, envelopeTemplateId, envelopeId, signingStatus } = lead;

  const { isLoading, resendNda } = useNdaStatus(leadId, envelopeId);

  if (!envelopeTemplateId || !isNdaSent(signingStatus)) return null;

  return (
    <Button
      className={classes}
      variant="outline"
      iconPosition="right"
      disabled={isLoading}
      icon={ArrowrightIcon}
      onClick={() => resendNda()}
    >
      {t('resendNDA')}
    </Button>
  );
};

export default ResendNda;
